import { NgModule } from '@angular/core'
import { ScopeDetailsComponent } from './scope-details.component'
import { DateFormatPipe } from '@app/shared/pipe/dateFormat.pipe'
import { ScopeUiOptionsMenuComponent } from '@app/shared/components/scope-ui-options-menu/scope-ui-options-menu.component'
import { MatDialogModule } from '@angular/material/dialog'
import { AsyncPipe, DecimalPipe, NgForOf, NgIf } from '@angular/common'
import { PipesModule } from '@app/shared/pipe/index.module'
import { MatDividerModule } from '@angular/material/divider'
import { ScopeUiInputComponent } from '@app/shared/components/ui-components/scope-ui-input/scope-ui-input.component'
import { ScopeUiAutocompleteComponent } from '@app/shared/components/ui-components/scope-ui-autocomplete/scope-ui-autocomplete.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatInputModule } from '@angular/material/input'
import { DirectivesModule } from '@app/shared/directives/index.module'
import { ScopeUiDatepickerComponent } from '@app/shared/components/ui-components/scope-ui-datepicker/scope-ui-datepicker.component'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { ScopeUiDropdownComponent } from '@app/shared/components/ui-components/scope-ui-dropdown/scope-ui-dropdown.component'
import { ScopeDetailsContainerComponent } from './scope-details-container.component'

@NgModule({
  declarations: [ScopeDetailsContainerComponent, ScopeDetailsComponent],
  exports: [ScopeDetailsContainerComponent],
  imports: [
    ScopeUiOptionsMenuComponent,
    MatDialogModule,
    AsyncPipe,
    PipesModule,
    NgIf,
    MatDividerModule,
    ScopeUiInputComponent,
    ScopeUiAutocompleteComponent,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    NgForOf,
    DirectivesModule,
    ScopeUiDatepickerComponent,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    DecimalPipe,
    ScopeUiDropdownComponent,
  ],
  providers: [DateFormatPipe],
})
export class ScopeDetailsModule {}
